import { render, staticRenderFns } from "./HeaderBase.vue?vue&type=template&id=4b46ae32&scoped=true&"
import script from "./HeaderBase.vue?vue&type=script&lang=ts&"
export * from "./HeaderBase.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderBase.vue?vue&type=style&index=0&id=4b46ae32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b46ae32",
  null
  
)

export default component.exports